import {Component, Input} from '@angular/core';

@Component({
  selector: 'brt-level-activity-label',
  templateUrl: './level-activity-label.component.html',
  styleUrls: ['./level-activity-label.component.scss']
})
export class LevelActivityLabelComponent {
  @Input('level') set setLevel(val: number) {
    switch (val) {
      case 2:
        this.levelTitle = "Aktiv";
        break;
      case 3:
        this.levelTitle = "Sehr aktiv";
        break;
      default:
        this.levelTitle = "Wenig aktiv";
    }
  }

  levelTitle = "Aktiv";
}
